import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WalletState } from './wallet.state';
import { walletFeatureKey } from './wallet.reducers';

export const selectWalletState = createFeatureSelector<WalletState>(walletFeatureKey);

export const selectWallet = createSelector(selectWalletState, (state: WalletState) => state);